<template>
  <v-container class="pb-5" fluid v-editable="blok">
    <v-row>
      <v-container>
        <v-row justify="center">
          <v-col cols="12">
            <div class="title mb-5">
              <h2>{{blok.title}}</h2>

              <div class="pb-icon">
                <div class="before">
                  <span>►</span>
                </div>
                <figure>
                  <img src="@/assets/logo_mini_dark.svg" alt />
                </figure>
                <div class="after">
                  <span>◄</span>
                </div>
              </div>
            </div>
            <p class="intro mt-5">{{blok.description}}</p>
          </v-col>
        </v-row>
        <v-row justify="center" >
          <v-col cols="12" sm="10" md="8" lg="6" xl="5">
              <v-sheet tile class="image" :style="'background-image: url('+blok.image+')'" height="350">                
              </v-sheet>
          </v-col>
        </v-row>
      </v-container>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: ["blok"]
};
</script>

<style lang="scss" scoped>
@import "./International.scss";
</style>